<template>
  <div id="dfHeader" :class="[background == 'blue' ? 'bluedfHeader' : 'dfHeader', border?'isboder':'']" v-if="(name != 'rule') && (name != 'invite') && (name != 'login')"  >
    <div class="indexSty" v-if="title == '大方租车'">
      <!--<img class="logo" src="@/assets/images/header/messageIcon.png" @click="goMessage()"/>-->
      <span></span>
      <img class="logo dafang" src="@/assets/images/header/index_title.png"/>
      <img class="logo" src="@/assets/images/header/userIcon.png"  @click="goUserCenter()"/>
    </div>
    <div v-else class="other">
      <div class="imgBlock" v-if="background == 'blue'"  @click="back()" >
        <img class="icon" src="@/assets/images/header/return.png"/>
      </div>
      <div class="imgBlock" v-else  @click="back()" >
        <img class="icon" src="@/assets/images/header/returnBlack.png"/>
      </div>
      <div class="title">{{title}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'dfHeader',
    data: function () {
      return {
        title: "大方租车",
        name:'',
        background:"",
        border:false
      }
    },
    created() {
      this.title = this.$route.meta.title;
      this.name = this.$route.name;

      if(this.$route.meta.background){
        this.background = this.$route.meta.background;
      }
    },
    mounted() {
      window.addEventListener('scroll',this.handleScroll, true);
    },
    watch: {
      $route(curVal, oldVal) {
        this.title = this.$route.meta.title;
        this.name = this.$route.name;

        if(this.$route.meta.background){
          this.background = this.$route.meta.background;
        }else{
          this.background = ""
        }
      }
    },
    methods: {
      back() {
        let backName = this.$route.meta.back;
        if (backName) {
          this.$router.replace({name: backName})
        }
        else {
          this.$router.replace({path: this.prevPath || "/index"})
        }

      },
      goMessage(){
        this.$router.replace({ path: "/MessageList" });
      },
      goUserCenter(){
        this.$router.replace({ path: "/userCenter" });
      },
      handleScroll(e){
        let scrollTop = e.target.offsetTop || e.target.scrollTop || e.srcElement.scrollTop;
        let offsetTop = document.querySelector('.orderList') ? (document.querySelector('.orderList').offsetTop || 0) : 0;

        // let scrollTop = document.querySelector('.app').scrollTop;
        // let offsetTop = 0
        if( document.querySelector('.orderList') ) {
          if( scrollTop > offsetTop){
            this.background = '';
            this.border = true;
          }else{
            this.background = 'blue';
            this.border = false;
          }
        }
      }
    }
  }
</script>
<style lang="scss" scoped type="text/scss">
  .dfHeader {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    border:0;
    margin:0;
    padding:0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 110px;
    background-color: #fff;
    .indexSty{
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
      .dafang{
        margin: 0 auto;
      }
    }
    .logo {
      height: 50px;
    }
  }
  .bluedfHeader {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 110px;
    color:#fff;
    .indexSty{
      display: flex;
      justify-content: space-between;
      width: 100%;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .logo {
      height: 50px;
    }
  }
  .isboder{
    border-bottom: 1px solid #9f9f9f;/* no */
  }
  .other{
    display: flex;
    align-items: center;
    .imgBlock{
      position: absolute;
      left: 0px;
      top: 0px;
      padding: 35px;
      box-sizing: border-box;
      width: 100px;
      height: 100px;
      .icon {
        width: 30px;
      }
    }
    .title {
      font-size: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/dfHeader.vue